import {
  getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationFetcher,
  getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { type AxiosError } from 'axios';

/**
 * 事業所更新フック
 */
export const usePutBranch = (
  threeLetterCode: string,
  branchId: number,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) =>
  useMutation(
    getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationKey(threeLetterCode, branchId),
    getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationFetcher(threeLetterCode, branchId),
    options
  );
